<script setup lang="ts">
  defineProps<{
    icon?: string,
  }>()
</script>

<template>
  <teleport to="#navbar-title">
    <span
      v-if="icon"
      class="mr-4 hidden text-xl text-primary-500 lg:inline-block">
      <fa-icon :icon="icon" />
    </span>
    <div class="truncate font-medium">
      <slot></slot>
    </div>
  </teleport>
</template>
